function initializeVideoLibrary() {
  const root = document.querySelector("[data-video-library]");
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = "true";
  const search = root.querySelector("[data-video-search]");
  const filter = root.querySelector("[data-video-filter]");
  const cards = Array.from(root.querySelectorAll("[data-video-title]"));
  const update = () => {
    let count = 0;
    cards.forEach(card => {
      const matches = card.dataset.videoTitle.includes(search.value.trim().toLowerCase()) &&
        (filter.value === "all" || (filter.value === "career" ? card.dataset.videoCareer === "true" : filter.value === "premium" ? card.dataset.videoPremium === "true" : card.dataset.videoAccess === filter.value));
      card.hidden = !matches;
      if (matches) count++;
    });
    root.querySelector("[data-video-results]").textContent = `${count} of ${cards.length} videos`;
    root.querySelector("[data-video-empty]").hidden = count > 0 || cards.length === 0;
  };
  root.querySelector("[data-video-filters]").hidden = false;
  search.addEventListener("input", update);
  filter.addEventListener("change", update);
  root.querySelector("[data-video-reset]").addEventListener("click", () => {
    search.value = ""; filter.value = "all"; update(); search.focus();
  });
  root.querySelectorAll(".ad-video-preview img").forEach(img => {
    const fallback = () => { img.hidden = true; };
    img.addEventListener("error", fallback);
    if (img.complete && !img.naturalWidth) fallback();
  });
}
document.addEventListener("DOMContentLoaded", initializeVideoLibrary);
document.addEventListener("turbolinks:load", initializeVideoLibrary);
if (document.readyState !== "loading") initializeVideoLibrary();
